import {StyleSheet} from '@react-pdf/renderer';
import {yellow} from 'styles/constants';

const textStyles = StyleSheet.create({
	base: {
		display: 'block',
	},
	white: {
		color: 'white',
	},
	yellow: {
		color: yellow,
	},
	heading: {
		fontSize: '36px',
		fontWeight: 'bold',
		textTransform: 'uppercase',
		color: yellow,
	},
	subHeading: {
		fontSize: '22px',
		fontWeight: 'bold',
		color: yellow,
	},
});

const layoutStyles = StyleSheet.create({
	page: {
		fontFamily: 'SofiaPro',
		flexDirection: 'column',
		backgroundColor: yellow,
		fontSize: '11px',
		width: '100%',
	},
	flexContainer: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'center',
	},
	container: {
		padding: '40px',
	},
	containerHorizontal: {
		paddingLeft: '40px',
		paddingRight: '40px',
	},
});

const imageStyles = StyleSheet.create({
	pageBackground: {
		position: 'absolute',
		minWidth: '100%',
		display: 'block',
		height: '30%',
		width: '100%',
	},
	sleipnerTopLogo: {
		width: '50px',
		height: '50px',
	},
	sleipnerFooterLogo: {
		width: '50px',
		height: '50px',
	},
});

export const styles = {
	layout: layoutStyles,
	text: textStyles,
	image: imageStyles,
};
